import * as goodsShelfManagement from '../services/goodsShelfManagement';

export default {
  namespace: 'goodsShelfManagementMolding',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
  },

  effects: {
    //货架列表
    *getQueryShelfList({ payload: { values } }, { call, put }) {
      const response = yield call(
        goodsShelfManagement.getQueryShelfList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          queryShelfList: response?.data,
        },
      });
    },

    *deleteShelf({ payload: { values }, callback }, { call }) {
      const res = yield call(goodsShelfManagement.deleteShelf, values);
      callback(res);
    },
    *canDeleteGoodsShelf({ payload: { values }, callback }, { call }) {
      const res = yield call(goodsShelfManagement.canDeleteGoodsShelf, values);
      callback(res);
    },
    //导出货架数据明细报表
    *exportShelfItemData({ payload: { values }, callback }, { call }) {
      const res = yield call(goodsShelfManagement.exportShelfItemData, values);
      callback(res);
    },
    //导出货架数据汇总报表
    *exportShelfSummaryData({ payload: { values }, callback }, { call }) {
      const res = yield call(
        goodsShelfManagement.exportShelfSummaryData,
        values,
      );
      callback(res);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
